/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * address-format-api
 * OpenAPI spec version: 1.0.0-20241212-122148-c469bb10
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import {
  useCallback
} from 'react';

import { useMutator } from '../useMutator.js';
export interface AddressFormat {
  country: string;
  lookupModes?: LookupMode[];
  ordering?: FieldName[];
  postalCodeFormat: FieldFormat;
  cityFormat: FieldFormat;
  streetFormat: FieldFormat;
  houseNumberFormat: FieldFormat;
  houseNumberSuffixFormat: FieldFormat;
  suburbFormat: FieldFormat;
  additionalAddressLineFormat?: FieldFormat;
  isPreviewVisible: boolean;
}

export interface AddressesLookupResponse {
  city: string;
  streets?: string[];
  suburbs?: string[];
}

export interface Autocomplete {
  fieldSize: FieldSize;
  isStrict: boolean;
  isRequired: boolean;
}

export interface Coordinate {
  latitude: number;
  longitude: number;
}

export type FieldFormat = Autocomplete | NotApplicable | Text;

export type FieldName = typeof FieldName[keyof typeof FieldName];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FieldName = {
  AdditionalAddressLine: 'AdditionalAddressLine',
  City: 'City',
  HouseNumber: 'HouseNumber',
  HouseNumberSuffix: 'HouseNumberSuffix',
  PostalCode: 'PostalCode',
  Street: 'Street',
  Suburb: 'Suburb',
} as const;

export interface FieldSize {
  mobile: number;
  desktop: number;
}

export interface InternalServerError {
  key: string;
  message: string;
}

export type LookupMode = typeof LookupMode[keyof typeof LookupMode];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LookupMode = {
  ByCity: 'ByCity',
  ByCountry: 'ByCountry',
  ByPostalCode: 'ByPostalCode',
  ByPostalCodeAndHouseNumber: 'ByPostalCodeAndHouseNumber',
  NotApplicable: 'NotApplicable',
} as const;

export interface NotApplicable { [key: string]: unknown }

export interface NotFound {
  key: string;
  message: string;
}

export interface Text {
  fieldSize: FieldSize;
  isRequired: boolean;
  isLookupable: boolean;
  maxLength: number;
  textTransforms?: TextTransform[];
  pattern?: string;
}

export type TextTransform = typeof TextTransform[keyof typeof TextTransform];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TextTransform = {
  NoWhitespace: 'NoWhitespace',
  OnlyDigits: 'OnlyDigits',
  Uppercase: 'Uppercase',
} as const;

/**
 * Get the addresses for the given carrier in the given country, at given postal and house number.
 */
export const useGetAddressByCarrierCountryPostalCodeAndHouseNumberHook = () => {
        const getAddressByCarrierCountryPostalCodeAndHouseNumber = useMutator<AddressesLookupResponse[]>();

        return useCallback((
    carrier: string,
    country: string,
    postalCode: string,
    houseNumber: number,
 signal?: AbortSignal
) => {
        return getAddressByCarrierCountryPostalCodeAndHouseNumber(
          {url: `/addresses/${carrier}/country/${country}/postal-code/${postalCode}/house-number/${houseNumber}`, method: 'GET', signal
    },
          );
        }, [getAddressByCarrierCountryPostalCodeAndHouseNumber])
      }
    

export const getGetAddressByCarrierCountryPostalCodeAndHouseNumberQueryKey = (carrier?: string,
    country?: string,
    postalCode?: string,
    houseNumber?: number,) => {
    return [`/addresses/${carrier}/country/${country}/postal-code/${postalCode}/house-number/${houseNumber}`] as const;
    }

    
export const useGetAddressByCarrierCountryPostalCodeAndHouseNumberQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetAddressByCarrierCountryPostalCodeAndHouseNumberHook>>>, TError = string | NotFound | InternalServerError>(carrier: string,
    country: string,
    postalCode: string,
    houseNumber: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAddressByCarrierCountryPostalCodeAndHouseNumberHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAddressByCarrierCountryPostalCodeAndHouseNumberQueryKey(carrier,country,postalCode,houseNumber);

  const getAddressByCarrierCountryPostalCodeAndHouseNumber =  useGetAddressByCarrierCountryPostalCodeAndHouseNumberHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetAddressByCarrierCountryPostalCodeAndHouseNumberHook>>>> = ({ signal }) => getAddressByCarrierCountryPostalCodeAndHouseNumber(carrier,country,postalCode,houseNumber, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(carrier && country && postalCode && houseNumber), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAddressByCarrierCountryPostalCodeAndHouseNumberHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAddressByCarrierCountryPostalCodeAndHouseNumberQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetAddressByCarrierCountryPostalCodeAndHouseNumberHook>>>>
export type GetAddressByCarrierCountryPostalCodeAndHouseNumberQueryError = string | NotFound | InternalServerError


export function useGetAddressByCarrierCountryPostalCodeAndHouseNumber<TData = Awaited<ReturnType<ReturnType<typeof useGetAddressByCarrierCountryPostalCodeAndHouseNumberHook>>>, TError = string | NotFound | InternalServerError>(
 carrier: string,
    country: string,
    postalCode: string,
    houseNumber: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAddressByCarrierCountryPostalCodeAndHouseNumberHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetAddressByCarrierCountryPostalCodeAndHouseNumberHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetAddressByCarrierCountryPostalCodeAndHouseNumberHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAddressByCarrierCountryPostalCodeAndHouseNumber<TData = Awaited<ReturnType<ReturnType<typeof useGetAddressByCarrierCountryPostalCodeAndHouseNumberHook>>>, TError = string | NotFound | InternalServerError>(
 carrier: string,
    country: string,
    postalCode: string,
    houseNumber: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAddressByCarrierCountryPostalCodeAndHouseNumberHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetAddressByCarrierCountryPostalCodeAndHouseNumberHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetAddressByCarrierCountryPostalCodeAndHouseNumberHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAddressByCarrierCountryPostalCodeAndHouseNumber<TData = Awaited<ReturnType<ReturnType<typeof useGetAddressByCarrierCountryPostalCodeAndHouseNumberHook>>>, TError = string | NotFound | InternalServerError>(
 carrier: string,
    country: string,
    postalCode: string,
    houseNumber: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAddressByCarrierCountryPostalCodeAndHouseNumberHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAddressByCarrierCountryPostalCodeAndHouseNumber<TData = Awaited<ReturnType<ReturnType<typeof useGetAddressByCarrierCountryPostalCodeAndHouseNumberHook>>>, TError = string | NotFound | InternalServerError>(
 carrier: string,
    country: string,
    postalCode: string,
    houseNumber: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAddressByCarrierCountryPostalCodeAndHouseNumberHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetAddressByCarrierCountryPostalCodeAndHouseNumberQueryOptions(carrier,country,postalCode,houseNumber,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get addresses by carrier in country, at given postal.
 */
export const useGetAddressesByCarrierCountryAndPostalCodeHook = () => {
        const getAddressesByCarrierCountryAndPostalCode = useMutator<AddressesLookupResponse[]>();

        return useCallback((
    carrier: string,
    country: string,
    postalCode: string,
 signal?: AbortSignal
) => {
        return getAddressesByCarrierCountryAndPostalCode(
          {url: `/addresses/${carrier}/country/${country}/postal-code/${postalCode}`, method: 'GET', signal
    },
          );
        }, [getAddressesByCarrierCountryAndPostalCode])
      }
    

export const getGetAddressesByCarrierCountryAndPostalCodeQueryKey = (carrier?: string,
    country?: string,
    postalCode?: string,) => {
    return [`/addresses/${carrier}/country/${country}/postal-code/${postalCode}`] as const;
    }

    
export const useGetAddressesByCarrierCountryAndPostalCodeQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetAddressesByCarrierCountryAndPostalCodeHook>>>, TError = NotFound | InternalServerError>(carrier: string,
    country: string,
    postalCode: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAddressesByCarrierCountryAndPostalCodeHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAddressesByCarrierCountryAndPostalCodeQueryKey(carrier,country,postalCode);

  const getAddressesByCarrierCountryAndPostalCode =  useGetAddressesByCarrierCountryAndPostalCodeHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetAddressesByCarrierCountryAndPostalCodeHook>>>> = ({ signal }) => getAddressesByCarrierCountryAndPostalCode(carrier,country,postalCode, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(carrier && country && postalCode), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAddressesByCarrierCountryAndPostalCodeHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAddressesByCarrierCountryAndPostalCodeQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetAddressesByCarrierCountryAndPostalCodeHook>>>>
export type GetAddressesByCarrierCountryAndPostalCodeQueryError = NotFound | InternalServerError


export function useGetAddressesByCarrierCountryAndPostalCode<TData = Awaited<ReturnType<ReturnType<typeof useGetAddressesByCarrierCountryAndPostalCodeHook>>>, TError = NotFound | InternalServerError>(
 carrier: string,
    country: string,
    postalCode: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAddressesByCarrierCountryAndPostalCodeHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetAddressesByCarrierCountryAndPostalCodeHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetAddressesByCarrierCountryAndPostalCodeHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAddressesByCarrierCountryAndPostalCode<TData = Awaited<ReturnType<ReturnType<typeof useGetAddressesByCarrierCountryAndPostalCodeHook>>>, TError = NotFound | InternalServerError>(
 carrier: string,
    country: string,
    postalCode: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAddressesByCarrierCountryAndPostalCodeHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetAddressesByCarrierCountryAndPostalCodeHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetAddressesByCarrierCountryAndPostalCodeHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAddressesByCarrierCountryAndPostalCode<TData = Awaited<ReturnType<ReturnType<typeof useGetAddressesByCarrierCountryAndPostalCodeHook>>>, TError = NotFound | InternalServerError>(
 carrier: string,
    country: string,
    postalCode: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAddressesByCarrierCountryAndPostalCodeHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAddressesByCarrierCountryAndPostalCode<TData = Awaited<ReturnType<ReturnType<typeof useGetAddressesByCarrierCountryAndPostalCodeHook>>>, TError = NotFound | InternalServerError>(
 carrier: string,
    country: string,
    postalCode: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAddressesByCarrierCountryAndPostalCodeHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetAddressesByCarrierCountryAndPostalCodeQueryOptions(carrier,country,postalCode,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get addresses by given carrier in the given country in the given city.
 */
export const useGetAddressesByCarrierCountryAndCityHook = () => {
        const getAddressesByCarrierCountryAndCity = useMutator<AddressesLookupResponse[]>();

        return useCallback((
    carrier: string,
    country: string,
    city: string,
 signal?: AbortSignal
) => {
        return getAddressesByCarrierCountryAndCity(
          {url: `/addresses/${carrier}/country/${country}/city/${city}`, method: 'GET', signal
    },
          );
        }, [getAddressesByCarrierCountryAndCity])
      }
    

export const getGetAddressesByCarrierCountryAndCityQueryKey = (carrier?: string,
    country?: string,
    city?: string,) => {
    return [`/addresses/${carrier}/country/${country}/city/${city}`] as const;
    }

    
export const useGetAddressesByCarrierCountryAndCityQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetAddressesByCarrierCountryAndCityHook>>>, TError = NotFound | InternalServerError>(carrier: string,
    country: string,
    city: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAddressesByCarrierCountryAndCityHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAddressesByCarrierCountryAndCityQueryKey(carrier,country,city);

  const getAddressesByCarrierCountryAndCity =  useGetAddressesByCarrierCountryAndCityHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetAddressesByCarrierCountryAndCityHook>>>> = ({ signal }) => getAddressesByCarrierCountryAndCity(carrier,country,city, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(carrier && country && city), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAddressesByCarrierCountryAndCityHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAddressesByCarrierCountryAndCityQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetAddressesByCarrierCountryAndCityHook>>>>
export type GetAddressesByCarrierCountryAndCityQueryError = NotFound | InternalServerError


export function useGetAddressesByCarrierCountryAndCity<TData = Awaited<ReturnType<ReturnType<typeof useGetAddressesByCarrierCountryAndCityHook>>>, TError = NotFound | InternalServerError>(
 carrier: string,
    country: string,
    city: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAddressesByCarrierCountryAndCityHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetAddressesByCarrierCountryAndCityHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetAddressesByCarrierCountryAndCityHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAddressesByCarrierCountryAndCity<TData = Awaited<ReturnType<ReturnType<typeof useGetAddressesByCarrierCountryAndCityHook>>>, TError = NotFound | InternalServerError>(
 carrier: string,
    country: string,
    city: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAddressesByCarrierCountryAndCityHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetAddressesByCarrierCountryAndCityHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetAddressesByCarrierCountryAndCityHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAddressesByCarrierCountryAndCity<TData = Awaited<ReturnType<ReturnType<typeof useGetAddressesByCarrierCountryAndCityHook>>>, TError = NotFound | InternalServerError>(
 carrier: string,
    country: string,
    city: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAddressesByCarrierCountryAndCityHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAddressesByCarrierCountryAndCity<TData = Awaited<ReturnType<ReturnType<typeof useGetAddressesByCarrierCountryAndCityHook>>>, TError = NotFound | InternalServerError>(
 carrier: string,
    country: string,
    city: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAddressesByCarrierCountryAndCityHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetAddressesByCarrierCountryAndCityQueryOptions(carrier,country,city,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get addresses by the given carrier in the given country.
 */
export const useGetAddressesByCarrierAndCountryHook = () => {
        const getAddressesByCarrierAndCountry = useMutator<AddressesLookupResponse[]>();

        return useCallback((
    carrier: string,
    country: string,
 signal?: AbortSignal
) => {
        return getAddressesByCarrierAndCountry(
          {url: `/addresses/${carrier}/country/${country}`, method: 'GET', signal
    },
          );
        }, [getAddressesByCarrierAndCountry])
      }
    

export const getGetAddressesByCarrierAndCountryQueryKey = (carrier?: string,
    country?: string,) => {
    return [`/addresses/${carrier}/country/${country}`] as const;
    }

    
export const useGetAddressesByCarrierAndCountryQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetAddressesByCarrierAndCountryHook>>>, TError = NotFound | InternalServerError>(carrier: string,
    country: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAddressesByCarrierAndCountryHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAddressesByCarrierAndCountryQueryKey(carrier,country);

  const getAddressesByCarrierAndCountry =  useGetAddressesByCarrierAndCountryHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetAddressesByCarrierAndCountryHook>>>> = ({ signal }) => getAddressesByCarrierAndCountry(carrier,country, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(carrier && country), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAddressesByCarrierAndCountryHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAddressesByCarrierAndCountryQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetAddressesByCarrierAndCountryHook>>>>
export type GetAddressesByCarrierAndCountryQueryError = NotFound | InternalServerError


export function useGetAddressesByCarrierAndCountry<TData = Awaited<ReturnType<ReturnType<typeof useGetAddressesByCarrierAndCountryHook>>>, TError = NotFound | InternalServerError>(
 carrier: string,
    country: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAddressesByCarrierAndCountryHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetAddressesByCarrierAndCountryHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetAddressesByCarrierAndCountryHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAddressesByCarrierAndCountry<TData = Awaited<ReturnType<ReturnType<typeof useGetAddressesByCarrierAndCountryHook>>>, TError = NotFound | InternalServerError>(
 carrier: string,
    country: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAddressesByCarrierAndCountryHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetAddressesByCarrierAndCountryHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetAddressesByCarrierAndCountryHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAddressesByCarrierAndCountry<TData = Awaited<ReturnType<ReturnType<typeof useGetAddressesByCarrierAndCountryHook>>>, TError = NotFound | InternalServerError>(
 carrier: string,
    country: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAddressesByCarrierAndCountryHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAddressesByCarrierAndCountry<TData = Awaited<ReturnType<ReturnType<typeof useGetAddressesByCarrierAndCountryHook>>>, TError = NotFound | InternalServerError>(
 carrier: string,
    country: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAddressesByCarrierAndCountryHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetAddressesByCarrierAndCountryQueryOptions(carrier,country,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get countries Express ships to.
 */
export const useGetExpressCountriesHook = () => {
        const getExpressCountries = useMutator<string[]>();

        return useCallback((
    
 signal?: AbortSignal
) => {
        return getExpressCountries(
          {url: `/addresses/express/countries`, method: 'GET', signal
    },
          );
        }, [getExpressCountries])
      }
    

export const getGetExpressCountriesQueryKey = () => {
    return [`/addresses/express/countries`] as const;
    }

    
export const useGetExpressCountriesQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetExpressCountriesHook>>>, TError = NotFound | InternalServerError>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetExpressCountriesHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetExpressCountriesQueryKey();

  const getExpressCountries =  useGetExpressCountriesHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetExpressCountriesHook>>>> = ({ signal }) => getExpressCountries(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetExpressCountriesHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetExpressCountriesQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetExpressCountriesHook>>>>
export type GetExpressCountriesQueryError = NotFound | InternalServerError


export function useGetExpressCountries<TData = Awaited<ReturnType<ReturnType<typeof useGetExpressCountriesHook>>>, TError = NotFound | InternalServerError>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetExpressCountriesHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetExpressCountriesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetExpressCountriesHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetExpressCountries<TData = Awaited<ReturnType<ReturnType<typeof useGetExpressCountriesHook>>>, TError = NotFound | InternalServerError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetExpressCountriesHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetExpressCountriesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetExpressCountriesHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetExpressCountries<TData = Awaited<ReturnType<ReturnType<typeof useGetExpressCountriesHook>>>, TError = NotFound | InternalServerError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetExpressCountriesHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetExpressCountries<TData = Awaited<ReturnType<ReturnType<typeof useGetExpressCountriesHook>>>, TError = NotFound | InternalServerError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetExpressCountriesHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetExpressCountriesQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get address formats for the given carrier in the given country.
 */
export const useGetAddressFormatByCarrierAndCountryHook = () => {
        const getAddressFormatByCarrierAndCountry = useMutator<AddressFormat>();

        return useCallback((
    carrier: string,
    country: string,
 signal?: AbortSignal
) => {
        return getAddressFormatByCarrierAndCountry(
          {url: `/address-formats/${carrier}/${country}`, method: 'GET', signal
    },
          );
        }, [getAddressFormatByCarrierAndCountry])
      }
    

export const getGetAddressFormatByCarrierAndCountryQueryKey = (carrier?: string,
    country?: string,) => {
    return [`/address-formats/${carrier}/${country}`] as const;
    }

    
export const useGetAddressFormatByCarrierAndCountryQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetAddressFormatByCarrierAndCountryHook>>>, TError = NotFound | InternalServerError>(carrier: string,
    country: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAddressFormatByCarrierAndCountryHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAddressFormatByCarrierAndCountryQueryKey(carrier,country);

  const getAddressFormatByCarrierAndCountry =  useGetAddressFormatByCarrierAndCountryHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetAddressFormatByCarrierAndCountryHook>>>> = ({ signal }) => getAddressFormatByCarrierAndCountry(carrier,country, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(carrier && country), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAddressFormatByCarrierAndCountryHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAddressFormatByCarrierAndCountryQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetAddressFormatByCarrierAndCountryHook>>>>
export type GetAddressFormatByCarrierAndCountryQueryError = NotFound | InternalServerError


export function useGetAddressFormatByCarrierAndCountry<TData = Awaited<ReturnType<ReturnType<typeof useGetAddressFormatByCarrierAndCountryHook>>>, TError = NotFound | InternalServerError>(
 carrier: string,
    country: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAddressFormatByCarrierAndCountryHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetAddressFormatByCarrierAndCountryHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetAddressFormatByCarrierAndCountryHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAddressFormatByCarrierAndCountry<TData = Awaited<ReturnType<ReturnType<typeof useGetAddressFormatByCarrierAndCountryHook>>>, TError = NotFound | InternalServerError>(
 carrier: string,
    country: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAddressFormatByCarrierAndCountryHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetAddressFormatByCarrierAndCountryHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetAddressFormatByCarrierAndCountryHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAddressFormatByCarrierAndCountry<TData = Awaited<ReturnType<ReturnType<typeof useGetAddressFormatByCarrierAndCountryHook>>>, TError = NotFound | InternalServerError>(
 carrier: string,
    country: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAddressFormatByCarrierAndCountryHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAddressFormatByCarrierAndCountry<TData = Awaited<ReturnType<ReturnType<typeof useGetAddressFormatByCarrierAndCountryHook>>>, TError = NotFound | InternalServerError>(
 carrier: string,
    country: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAddressFormatByCarrierAndCountryHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetAddressFormatByCarrierAndCountryQueryOptions(carrier,country,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get coordinates for the given country and postal code.
 */
export const useGetCoordinatesByCountryAndPostalCodeEndpointHook = () => {
        const getCoordinatesByCountryAndPostalCodeEndpoint = useMutator<Coordinate>();

        return useCallback((
    country: string,
    postalCode: string,
 signal?: AbortSignal
) => {
        return getCoordinatesByCountryAndPostalCodeEndpoint(
          {url: `/coordinates/${country}/${postalCode}`, method: 'GET', signal
    },
          );
        }, [getCoordinatesByCountryAndPostalCodeEndpoint])
      }
    

export const getGetCoordinatesByCountryAndPostalCodeEndpointQueryKey = (country?: string,
    postalCode?: string,) => {
    return [`/coordinates/${country}/${postalCode}`] as const;
    }

    
export const useGetCoordinatesByCountryAndPostalCodeEndpointQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetCoordinatesByCountryAndPostalCodeEndpointHook>>>, TError = NotFound | InternalServerError>(country: string,
    postalCode: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCoordinatesByCountryAndPostalCodeEndpointHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCoordinatesByCountryAndPostalCodeEndpointQueryKey(country,postalCode);

  const getCoordinatesByCountryAndPostalCodeEndpoint =  useGetCoordinatesByCountryAndPostalCodeEndpointHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetCoordinatesByCountryAndPostalCodeEndpointHook>>>> = ({ signal }) => getCoordinatesByCountryAndPostalCodeEndpoint(country,postalCode, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(country && postalCode), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCoordinatesByCountryAndPostalCodeEndpointHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCoordinatesByCountryAndPostalCodeEndpointQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetCoordinatesByCountryAndPostalCodeEndpointHook>>>>
export type GetCoordinatesByCountryAndPostalCodeEndpointQueryError = NotFound | InternalServerError


export function useGetCoordinatesByCountryAndPostalCodeEndpoint<TData = Awaited<ReturnType<ReturnType<typeof useGetCoordinatesByCountryAndPostalCodeEndpointHook>>>, TError = NotFound | InternalServerError>(
 country: string,
    postalCode: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCoordinatesByCountryAndPostalCodeEndpointHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetCoordinatesByCountryAndPostalCodeEndpointHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetCoordinatesByCountryAndPostalCodeEndpointHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCoordinatesByCountryAndPostalCodeEndpoint<TData = Awaited<ReturnType<ReturnType<typeof useGetCoordinatesByCountryAndPostalCodeEndpointHook>>>, TError = NotFound | InternalServerError>(
 country: string,
    postalCode: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCoordinatesByCountryAndPostalCodeEndpointHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetCoordinatesByCountryAndPostalCodeEndpointHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetCoordinatesByCountryAndPostalCodeEndpointHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCoordinatesByCountryAndPostalCodeEndpoint<TData = Awaited<ReturnType<ReturnType<typeof useGetCoordinatesByCountryAndPostalCodeEndpointHook>>>, TError = NotFound | InternalServerError>(
 country: string,
    postalCode: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCoordinatesByCountryAndPostalCodeEndpointHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetCoordinatesByCountryAndPostalCodeEndpoint<TData = Awaited<ReturnType<ReturnType<typeof useGetCoordinatesByCountryAndPostalCodeEndpointHook>>>, TError = NotFound | InternalServerError>(
 country: string,
    postalCode: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCoordinatesByCountryAndPostalCodeEndpointHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetCoordinatesByCountryAndPostalCodeEndpointQueryOptions(country,postalCode,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}
